export default __webpack_public_path__ + "static/media/pulse.19761872.wav";